import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faFloppyDisk,
  faCompactDisc,
  faGhost,
  faChessRook,
  faDesktop,
  faSpider
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';

export const ZZZMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/zenless/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/zenless/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" /> <span>Agents</span>
        </Nav.Link>
      </Link>
      <Link to="/zenless/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/zenless/shiyu-defense">
        <Nav.Link as="span" eventKey="shiyu" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faChessRook} width="18" />{' '}
          <span>Shiyu Defense</span>
        </Nav.Link>
      </Link>
      <Link to="/zenless/deadly-assault">
        <Nav.Link as="span" eventKey="deadly" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faSpider} width="18" />{' '}
          <span>Deadly Assault</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/zenless/bangboo">
        <Nav.Link as="span" eventKey="bangboo" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faGhost} width="18" /> <span>Bangboo</span>
        </Nav.Link>
      </Link>
      <Link to="/zenless/w-engines">
        <Nav.Link as="span" eventKey="w-engines" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faFloppyDisk} width="18" />{' '}
          <span>W-Engines</span>
        </Nav.Link>
      </Link>
      <Link to="/zenless/disk-drives">
        <Nav.Link as="span" eventKey="disk-drives" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faCompactDisc} width="18" />{' '}
          <span>Drive Disks</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/zenless/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/zenless/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
      <hr />
      <Link to="/zenless/play-on-pc">
        <Nav.Link
          as="span"
          className="special"
          eventKey="play-on-pc"
          onClick={handleOnClick}
        >
          <FontAwesomeIcon icon={faDesktop} width="18" />{' '}
          <span>Play on PC</span>
        </Nav.Link>
      </Link>
    </Nav>
  );
};
